import { useRecoilValue, useSetRecoilState } from "recoil";
import { alertListState, removeAlertStateSelector } from "../store/AlertState";
import { Snackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab";

export const AlertDisplay = () => {
  const alertList = useRecoilValue(alertListState);
  const removeAlert = useSetRecoilState(removeAlertStateSelector);

  if (alertList.length === 0) {
    return null;
  }

  const handleClose = alertInfo => {
    removeAlert(alertInfo);
  };

  const verticalOffset = {
    top: {
      left: null,
      center: null,
      right: null
    },
    bottom: {
      left: null,
      center: null,
      right: null
    }
  };

  return (
    <>
      {alertList.map(alertInfo => {
        const pos = alertInfo.option.position;
        const offsetValue = verticalOffset[pos[0]][pos[1]] || alertInfo.option.verticalOffset;
        const style = {
          [pos[0]]: offsetValue
        };

        if (pos[1] !== 'center') {
          style[pos[1]] = alertInfo.option.horizontalOffset;
        }

        verticalOffset[pos[0]][pos[1]] = offsetValue + 56;

        return (
          <Snackbar open={true} key={alertInfo.id} anchorOrigin={{vertical: pos[0], horizontal: pos[1]}} style={style}>
            {alertInfo.option.close ?
              <Alert severity={alertInfo.type} onClose={()=>{handleClose(alertInfo)}}>{alertInfo.text}</Alert>
              : <Alert severity={alertInfo.type}>{alertInfo.text}</Alert>
            }
          </Snackbar>
        );
      })}
    </>
  );
};

